import React from 'react';
import { Sparkles } from 'lucide-react';
import { formatLastActive } from './_utils';

/**
 * SponsorshipInbox — read-only list of sponsored-account applications
 * submitted from /impact. Reply happens via the applicant's email.
 * Extracted from Admin.jsx.
 */
const SponsorshipInbox = ({ sponsorships }) => (
  <div className="bg-enf-surface-deep border border-enf-surface-border rounded-xl p-6 mb-10" data-testid="admin-sponsorship-card">
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-enf-accent-fg" />
        <div className="text-sm font-semibold uppercase tracking-widest text-enf-text-secondary">Sponsored-account applications</div>
      </div>
      <span className="text-xs text-enf-text-muted" data-testid="admin-sponsorship-count">{sponsorships.length} total</span>
    </div>

    {sponsorships.length === 0 ? (
      <div className="text-sm text-enf-text-muted py-6 text-center">
        No applications yet. They land here when someone submits the form on /impact.
      </div>
    ) : (
      <div className="space-y-3">
        {sponsorships.map((s) => (
          <div
            key={s.id}
            className="bg-enf-surface-mid border border-enf-surface-border rounded-lg p-4"
            data-testid={`sponsorship-row-${s.id}`}
          >
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-enf-text-primary">{s.name} <span className="text-enf-text-muted font-normal text-xs">· {s.category}</span></div>
                <div className="text-xs text-enf-text-muted mt-1 flex flex-wrap gap-x-3 gap-y-1">
                  <a href={`mailto:${s.email}`} className="hover:text-enf-role-info">{s.email}</a>
                  {s.reference_org && <span><span className="text-enf-text-muted">Ref:</span> {s.reference_org}</span>}
                  {s.submitted_at && <span><span className="text-enf-text-muted">Received:</span> {formatLastActive(s.submitted_at)}</span>}
                </div>
                <div className="text-xs text-enf-text-secondary mt-2 whitespace-pre-wrap leading-relaxed border-l-2 border-enf-surface-border pl-3">
                  {s.story}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}

    <div className="mt-4 pt-4 border-t border-enf-surface-border text-xs text-enf-text-muted">
      Reply via the applicant's email address. Approval/denial workflow + grant tracking ships when Stripe is wired.
    </div>
  </div>
);

export default SponsorshipInbox;
